import { parseTeamsFromUrl, Selection } from './state.js';
import { mountSelectScreen } from './select.js';
import { mountSubscribeScreen } from './subscribe.js';
import { getLang, setLang, applyTranslations, renderLangList, type LangCode } from './i18n.js';
import { initAnalytics, track } from './analytics.js';

const initial = parseTeamsFromUrl(window.location.search);
const selection = new Selection(initial);

declare global {
  interface Window { WCC: { selection: Selection } }
}
window.WCC = { selection };

function mountLangSheet(): void {
  const btn = document.getElementById('lang-btn');
  const backdrop = document.getElementById('lang-backdrop');
  const sheet = document.getElementById('lang-sheet');
  const list = document.getElementById('lang-list');
  if (!btn || !backdrop || !sheet || !list) return;

  function open(): void {
    sheet!.hidden = false;
    backdrop!.hidden = false;
  }
  function close(): void {
    sheet!.hidden = true;
    backdrop!.hidden = true;
  }
  function onSelect(code: string): void {
    setLang(code as LangCode);
    renderLangList(list!, onSelect);
    close();
  }

  renderLangList(list, onSelect);
  btn.addEventListener('click', open);
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !sheet!.hidden) close();
  });
}

function init(): void {
  initAnalytics();

  const lang = getLang();
  setLang(lang);

  mountSelectScreen(selection);
  mountSubscribeScreen(selection);
  mountLangSheet();
  applyTranslations();

  document.querySelectorAll<HTMLAnchorElement>('a[href*="/faq"]').forEach((link) => {
    link.addEventListener('click', () => track('faq_link_clicked', { lang: getLang() }));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
